module.exports = __webpack_public_path__ + "static/008084-ecad458a06425f3cdc29fed9baf26e47.jpg";